class Api {
    // Use relative URLs in production (when served via Caddy), otherwise use full URL
    baseUrl = process.env.REACT_APP_PROTOCOL === 'https' || !process.env.REACT_APP_BACKEND_PORT
        ? '/api'  // Relative URL works with Caddy reverse proxy
        : `http://${process.env.REACT_APP_HOST}:${process.env.REACT_APP_BACKEND_PORT}/api`;

    get(path) {
        return this.request("GET", path);
    }

    post(path, body) {
        return this.request("POST", path, body);
    }

    patch(path, body) {
        return this.request("PATCH", path, body);
    }

    delete(path) {
        return this.request("DELETE", path);
    }

    async request(method, path, body, customHeaders = {}) {
        try {
            const token = localStorage.getItem('token');

            const headers = {
                ...(token ? { "Authorization": `Bearer ${token}` } : {}),
                ...customHeaders, // Custom headers override default headers
            };

            const response = await fetch(`${this.baseUrl}${path}`, {
                method: method,
                body: body instanceof FormData ? body : body ? JSON.stringify(body) : undefined,
                headers: body instanceof FormData ? headers : { "Content-Type": "application/json", ...headers },
            });

            if (response.status >= 200 && response.status < 300) {
                const contentType = response.headers.get("Content-Type");

                // Check if the response is JSON or binary data (PDF in this case)
                if (contentType && contentType.includes("application/json")) {
                    return response.json(); // If it's JSON, parse it
                } else {
                    return response.blob(); // If it's binary (PDF, image, etc.), return as Blob
                }
            } else {
                // Handle error responses - try to parse as JSON, but handle non-JSON errors
                let errorMessage = response.statusText;
                try {
                    const errorData = await response.json();
                    errorMessage = errorData.message || errorData.error || response.statusText;
                } catch (e) {
                    // If response is not JSON, try to get text
                    try {
                        const errorText = await response.text();
                        errorMessage = errorText || response.statusText;
                    } catch (textError) {
                        // If all else fails, use status text
                        errorMessage = response.statusText;
                    }
                }
                
                // Handle 401 Unauthorized specifically
                if (response.status === 401) {
                    // Clear token and redirect to login
                    localStorage.removeItem('token');
                    throw new Error("Session expired. Please log in again.");
                }
                
                throw new Error(errorMessage);
            }
        } catch (error) {
            throw new Error(error.message || "Network Error");
        }
    }

}

const api = new Api();

export default api;